import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers/index.js'
import initialState from './initial.js'

const store = createStore(
	reducers,
	initialState,
	applyMiddleware(thunk)
)

window.store = store // remove for production

export default store
